export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./taxes.vue?vue&type=template&id=266310a0"


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/taxes.vue?vue&type=template&id=266310a0
// module id = waJx
// module chunks = 0